import * as React from "react"
const Trends = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.876 8.75-6.852 6.852c-.244.244-.366.366-.43.498a.895.895 0 0 0 0 .795c.064.131.186.253.43.497s.366.366.498.432c.25.124.545.124.795 0 .132-.066.254-.188.498-.432l6.852-6.852 1.975-1.975c.244-.244.366-.366.432-.498a.895.895 0 0 0 0-.795c-.066-.132-.188-.254-.432-.498s-.366-.366-.497-.43a.895.895 0 0 0-.795 0c-.132.064-.254.186-.498.43L9.876 8.75Zm1.79 1.79-1.79-1.79"
    />
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.25 2.083-.092.249c-.12.326-.181.49-.3.609-.12.119-.283.18-.61.3L15 3.333l.249.092c.326.12.49.181.609.3.119.12.18.283.3.61l.092.248.092-.249c.12-.326.181-.49.3-.609.12-.119.283-.18.61-.3l.248-.092-.249-.092c-.326-.12-.49-.181-.609-.3-.119-.12-.18-.283-.3-.609l-.092-.249ZM16.25 10.416l-.092.25c-.12.326-.181.49-.3.608-.12.12-.283.18-.61.3l-.248.092.249.093c.326.12.49.18.609.3.119.119.18.282.3.609l.092.248.092-.248c.12-.327.181-.49.3-.61.12-.118.283-.179.61-.3l.248-.091-.249-.093c-.326-.12-.49-.18-.609-.3-.119-.119-.18-.282-.3-.609l-.092-.248ZM8.75 2.083l-.092.249c-.12.326-.181.49-.3.609-.12.119-.283.18-.61.3l-.248.092.249.092c.326.12.49.181.609.3.119.12.18.283.3.61l.092.248.092-.249c.12-.326.181-.49.3-.609.12-.119.283-.18.61-.3L10 3.333l-.249-.092c-.326-.12-.49-.181-.609-.3-.119-.12-.18-.283-.3-.609l-.092-.249Z"
    />
  </svg>
)
export default Trends
